<template>
    <pendo-star-cell
        class="star-filter"
        :row="{ starred: value }"
        action-type="filter"
        :disabled="disabled"
        @star-change="toggleFilter" />
</template>

<script>
import { PendoStarCell } from '@pendo/components';

export default {
    name: 'StarFilter',
    components: {
        PendoStarCell,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change'],
    methods: {
        toggleFilter () {
            this.$emit('change', !this.value);
        },
    },
};
</script>

<style scoped lang="less">
.star-filter {
    border: solid 1px var(--palette-gray-40) !important;
    border-radius: 3px;
    padding: 9px;
    width: 36px;
    transition: all 0.2s;
}
// .star-filter-wrapper {
//     .star-filter {
//         border: solid 1px var(--palette-gray-40);
//         border-radius: 3px;
//         padding: 9px;
//         transition: all 0.2s;

//         &:hover {
//             border: solid 1px var(--palette-gray-90);
//             cursor: pointer;
//         }
//     }

//     &.disabled {
//         background-color: var(--palette-gray-20);
//         color: var(--palette-gray-70);
//         border-color: var(--palette-gray-40);
//         cursor: not-allowed;

//         .star-filter {
//             pointer-events: none;
//         }
//     }
// }
</style>
